import { defiItemFields } from '@/pages/defi-exposure/models/defi-fields'

export default {
  showCreateEditModal: false,
  modalAction: 'create',
  createEditModalData: defiItemFields(),
}
